import { LocationsEnum } from './enums';
import { ICoordinatesModel } from './interfaces/coordinatesModelInterface';
import { CoordinatesModel } from "./models";

export class LocationsConstants {

  static getLocationCoordinates = (location: LocationsEnum): CoordinatesModel => {
    let locationCoordinates: ICoordinatesModel;
    switch (location) {
      case LocationsEnum.Ayas:
        locationCoordinates = {
          latitude: 40.03108820366695,
          longitude: 32.32836083690384,
          plaka: 6,
          stationId: 18045,
          elevation: 1134,
          radarPath: 'ank/ank',
          takeoffWindDirection: ['N', 'NW', 'NNW', 'SW', 'W', 'WSW']
        }
        break;
      case LocationsEnum.Uregil:
        locationCoordinates = {
          latitude: 40.27945625032616,
          longitude: 32.07312365442611,
          plaka: 6,
          stationId: 17680,
          elevation: 1333,
          radarPath: 'ank/ank'
        }
        break;
      case LocationsEnum.Aksehir:
        locationCoordinates = {
          latitude: 38.328034,
          longitude: 31.418396,
          plaka: 42,
          stationId: 17680,
          elevation: 1487,
          radarPath: 'ank/ank'
        }
        break;
    case LocationsEnum.Alanya:
        locationCoordinates = {
          latitude: 36.57626710631509,
          longitude: 31.970961971757866,
          plaka: 7,
          stationId: 17310,
          elevation: 680,
          radarPath: 'ant/ant',
          takeoffWindDirection: ['S', 'SE', 'SW','SE']
        }
        break;
      case LocationsEnum.Corum:
        locationCoordinates = {
          latitude: 40.72832861073192,
          longitude: 34.6789931637603,
          plaka: 19,
          stationId: 91912,
          elevation: 1250,
          radarPath: 'ank/ank',
          takeoffWindDirection: ['N', 'NE', 'NNE']
        }
        break;
      case LocationsEnum.Ormanli:
        locationCoordinates = {
          latitude: 41.40769028744866,
          longitude: 28.487119663020167,
          plaka: 34,
          stationId: 91912,
          elevation: 50,
          radarPath: 'ist/ist',
          takeoffWindDirection: ['N', 'NE', 'NNE','NW','NNW']
        }
        break;
      case LocationsEnum.Oludeniz_1700:
        locationCoordinates = {
          latitude: 36.53901011369937,
          longitude: 29.169479240037898,
          plaka: 7,
          stationId: 17310,
          elevation: 1700,
          radarPath: 'ant/ant',
          takeoffWindDirection: ['W', 'SW', 'WSW']
        }
        break;
    }
    return new CoordinatesModel(locationCoordinates);
  };
}
